import { Color, Flex, ProgressBar, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { MAX_STEP_COUNT } from '../../../../constants/stepCount'
import { useEInvoicingSetup } from '../../../../hooks/useEInvoicingSetup'
import * as Styled from './styles'

export interface EInvoicingProgressBarProps {
  title: string
}

export const EInvoicingProgressBar = ({ title }: EInvoicingProgressBarProps): ReactElement => {
  const { t } = useTranslation()

  const { currentStepCount } = useEInvoicingSetup()
  const progressPercent = (currentStepCount / MAX_STEP_COUNT) * 100

  return (
    <Styled.ProgressBarContainer>
      <Styled.ProgressBarContent>
        <Flex width="100%" justifyContent="center">
          <Text uppercase colorVariant="secondary" weight="bold" variant="bodySM">
            {t('e_invoice.kyc.step')} {currentStepCount}/{MAX_STEP_COUNT} - {title}
          </Text>
        </Flex>
        <Space size="s8" />
        <ProgressBar backgroundColor={Color.Grey200} progressColor={Color.Black} progress={progressPercent} />
      </Styled.ProgressBarContent>
    </Styled.ProgressBarContainer>
  )
}
